module.exports = __webpack_public_path__ + "img/fossil3Img1.90b79131.jpg";